import React from 'react';
import { Box } from '@mui/material';
import { usePWAStatus } from '../../hooks/usePWAStatus';
import { runtime } from '../../platform/runtime';

/**
 * Layout wrapper that provides proper spacing when bottom navigation is active
 */
const AppLayout = ({ children }) => {
    const { isPWA } = usePWAStatus();
    const isAppShell = runtime.isNative() || isPWA;

    return (
        <Box
            sx={{
                // Leave room for the navigation and the device's home indicator.
                paddingBottom: isAppShell ? 'calc(16px + var(--app-bottom-nav-height, calc(70px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))))' : 0,
                paddingLeft: runtime.isNative() ? 'var(--safe-area-inset-left, env(safe-area-inset-left, 0px))' : 0,
                paddingRight: runtime.isNative() ? 'var(--safe-area-inset-right, env(safe-area-inset-right, 0px))' : 0,
            }}
        >
            {children}
        </Box>
    );
};

export default AppLayout;
